import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=74c83c94&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74c83c94')) {
      api.createRecord('74c83c94', component.options)
    } else {
      api.reload('74c83c94', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=74c83c94&", function () {
      api.rerender('74c83c94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GbeC5qQzx6Xf/JS/comp/IncreaseNumber.vue"
export default component.exports